import { ApiClient } from "~/application/types/classes/ApiClient.class";
import { getIntegrationsHubApiKey, getIntegrationsHubApiUrl } from "~/utils/env";

const integrationsHubApi = new ApiClient({
  baseUrl: getIntegrationsHubApiUrl(),
  timeoutMs: 1000 * 60 * 3, // 3 minutes
});

// Attach the static API key to every request. This client is intentionally
// separate from the shared `api` singleton so it does NOT carry biztrip-web's
// Bearer-token / 401-refresh interceptor.
integrationsHubApi.instance.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  config.headers["x-api-key"] = getIntegrationsHubApiKey();
  return config;
});

export { integrationsHubApi };
